var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.descriptionParts[0])+" "),_c('a',{attrs:{"href":"javascript:;","title":"View Activity"},on:{"click":function($event){return _vm.goToActivity(_vm.item.activity_id)}}},[_vm._v("#"+_vm._s(_vm.descriptionParts[1]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }